import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { InteriorDetailingPage } from './pages/InteriorDetailingPage';
import { ExteriorDetailingPage } from './pages/ExteriorDetailingPage';
import { FullCarDetailPage } from './pages/FullCarDetailPage';
import { HybridCeramicSprayPage } from './pages/HybridCeramicSprayPage';
import { HeadlightRestorationPage } from './pages/HeadlightRestorationPage';
import { MobileDetailingPage } from './pages/MobileDetailingPage';
import { EngineBayDetailingPage } from './pages/EngineBayDetailingPage';
import { CityPage } from './pages/CityPage';
import { CityAliasRedirect } from './pages/CityAliasRedirect';
import { NotFoundPage } from './pages/NotFoundPage';
import { ContentExportPage } from './pages/ContentExportPage';
import { FaqPage } from './pages/FaqPage';
export function App() {
  useEffect(() => {
    // Google Analytics (gtag.js)
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-BBSL5F5SDB';
    document.head.appendChild(script);
    const inlineScript = document.createElement('script');
    inlineScript.textContent = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-BBSL5F5SDB');
      gtag('config', 'AW-349742034');
    `;
    document.head.appendChild(inlineScript);
  }, []);
  return <BrowserRouter data-id="element-0" data-mp="33n6y54p9hv5d">
      <Routes data-id="element-1" data-mp="33orki71fa7s5">
        <Route path="/" element={<HomePage data-id="element-3" data-mp="38l8eviz7tido" />} data-id="element-2" data-mp="38lro8basuyg3" />
        <Route path="/services/interior-detailing" element={<InteriorDetailingPage data-id="element-5" data-mp="3dkuwe4m2tksa" />} data-id="element-4" data-mp="38l04pyuh8r66" />
        <Route path="/services/exterior-detailing" element={<ExteriorDetailingPage data-id="element-7" data-mp="3dii5h1ycc033" />} data-id="element-6" data-mp="3dlw5w4ng1z7w" />
        <Route path="/services/full-car-detail" element={<FullCarDetailPage data-id="element-9" data-mp="nxn6nvnsp9oy" />} data-id="element-8" data-mp="nwc2vvuco1xu" />
        <Route path="/services/hybrid-ceramic-spray" element={<HybridCeramicSprayPage data-id="element-11" data-mp="ssspumptca9c" />} data-id="element-10" data-mp="sudlkfnv5z8s" />
        <Route path="/services/headlight-restoration" element={<HeadlightRestorationPage data-id="element-13" data-mp="34x3flo0nh5h" />} data-id="element-12" data-mp="36hzjfpzb85g" />
        <Route path="/services/mobile-detailing" element={<MobileDetailingPage data-id="element-15" data-mp="3ubzu8bzxzlf6" />} data-id="element-14" data-mp="3uct2jhejuizf" />
        <Route path="/services/engine-bay-detailing" element={<EngineBayDetailingPage data-id="element-17" data-mp="d3mmvivk99nu" />} data-id="element-16" data-mp="3uf5ijp0qyj9u" />
        {/* The old Ceramic Coating URL now points at the service actually
            offered, so the previously indexed URL keeps its link equity. */}
        <Route path="/services/ceramic-coating" element={<Navigate to="/services/hybrid-ceramic-spray" replace data-id="element-19" data-mp="3gja8m8obsiil" />} data-id="element-18" data-mp="3gklce8hrtq9p" />
        <Route path="/faq" element={<FaqPage data-id="element-21" data-mp="3bk70uggyny6x" />} data-id="element-20" data-mp="3bnmf5h2t937a" />
        {/* Canonical city landing pages. */}
        <Route path="/mobile-detailing-:slug" element={<CityPage data-id="element-23" data-mp="3lkheg26wr7mm" />} data-id="element-22" data-mp="3qbzgyuokxg9p" />
        {/* Previous city URL shape — redirects to the canonical version. */}
        <Route path="/ventura-county/:slug" element={<CityAliasRedirect data-id="element-25" data-mp="2xtv94ioag1gb" />} data-id="element-24" data-mp="2xuwuph2xk6ca" />
        {/* Documentation-only content export. Not linked in navigation, noindex. */}
        <Route path="/content-export" element={<ContentExportPage data-id="element-27" data-mp="18drk5y5ejjev" />} data-id="element-26" data-mp="2svadyxnw87yq" />
        <Route path="*" element={<NotFoundPage data-id="element-29" data-mp="18c6qeaqww4i2" />} data-id="element-28" data-mp="18cq7jp8qmov1" />
      </Routes>
    </BrowserRouter>;
}